(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choiceSection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {
    if ( document.querySelectorAll('.mediaContainer video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('.mediaContainer video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
        } else {
          thisVideoEl.pause();
        }

      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membershipSection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {

    if ( document.querySelectorAll('video[loop]').length > 0) {
      var windowHeight = window.innerHeight,
          videoEl = document.querySelectorAll('video[loop]');

      for (var i = 0; i < videoEl.length; i++) {

        var thisVideoEl = videoEl[i],
            videoHeight = thisVideoEl.clientHeight,
            videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
          thisVideoEl.play();
          // console.log("video playing");
        } else {
          thisVideoEl.pause();
          // console.log("video is not playing");
        }

      }
    }

  }

  } catch(e) { console.error(e); }
})();
})();
